import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
  email: string;
};

export const ResendInviteModal = ({ onCancel, onSuccess, email }: TProps) => {
  return (
    <ModalWrapper width="300px">
      <ModalTitle>Confirm</ModalTitle>
      <div className="text-center">Resend the invitation to {email}?</div>
      <form
        action="#"
        onSubmit={() => {
          onSuccess();
        }}
      >
        <div className="flex w-full gap-2.5">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button type="submit">Resend</Button>
        </div>
      </form>
    </ModalWrapper>
  );
};
